// import { CommercialCode } from "pages";
import { lazy } from "react";

//lazy-loaded Layouts
const DashboardLayout = lazy(() =>
  import("layouts").then((module) => ({ default: module.DashboardLayout }))
);
const AuthLayout = lazy(() =>
  import("layouts").then((module) => ({ default: module.AuthLayout }))
);
// const ProfileLayout = lazy(() =>
//   import("layouts").then((module) => ({ default: module.ProfileLayout }))
// );

// lazy-loaded Pages
const lazyLoad = (moduleName) =>
  lazy(() =>
    import("pages").then((module) => ({ default: module[moduleName] }))
  );

const Login = lazyLoad("Login");
const Verify = lazyLoad("Verify");
const Dashboard = lazyLoad("Dashboard");
const Company = lazyLoad("Company");
const MaterialCategory = lazyLoad("MaterialCategory");
const User = lazyLoad("User");
const Banner = lazyLoad("Banner");
const Setting = lazyLoad("Setting");
const Plans = lazyLoad("Plans");
const AddPlans = lazyLoad("AddPlans");
const ViewPlan = lazyLoad("ViewPlan");
const Location = lazyLoad("Location");
const commercialcode = lazyLoad("CommercialCode");
const CompanyDetails = lazyLoad("CompanyDetails");
const UserDetails = lazyLoad("UserDetails");
const ChartOfAccount = lazyLoad("ChartOfAccount");
const Sifarish = lazyLoad("Sifarish");
const SifarishDetail = lazyLoad("SifarishDetail");
const ReportedSifarish = lazyLoad("ReportedSifarish");
const DeletedSifarish = lazyLoad("DeletedSifarish");
const UserSifarishs = lazyLoad("UserSifarishs");
const Categories = lazyLoad("Categories");
const CategoriesDetail = lazyLoad("CategoriesDetail");
const Session = lazyLoad("Session");
const ManageAppVersion = lazyLoad("ManageAppVersion");
const Brodcasting = lazyLoad("Brodcasting");
const Contact = lazyLoad("Contact");
const SifarishPoints = lazyLoad("SifarishPoints");
const Leaderboard = lazyLoad("Leaderboard");
const BrodcastingHistory = lazyLoad("BrodcastingHistory");
const DeletedUser = lazyLoad("DeletedUser");
const BusinessProfileRequests = lazyLoad("BusinessProfileRequests");
const BusinessProfileRequestDetail = lazyLoad("BusinessProfileRequestDetail");

// creating route objects
const createRoute = (path, element, isPrivate = false) => ({
  path,
  element,
  isPrivate,
});

export const routeConfigs = [
  {
    layout: AuthLayout,
    children: [
      createRoute("/", Login, false),
      createRoute("other", Login, false),
      createRoute("verify", Verify, false),
    ],
  },
  {
    layout: DashboardLayout,
    children: [
      createRoute("dashboard", Dashboard, true),
      createRoute("company", Company, true),
      createRoute("material_category", MaterialCategory, true),
      createRoute("banner", Banner, true),
      createRoute("setting", Setting, true),
      // createRoute("verify", Verify, false),
      createRoute("plans", Plans, true),
      createRoute("location", Location, true),
      createRoute("commercialcode", commercialcode, true),
      createRoute("ChartOfAccount", ChartOfAccount, true),
      createRoute("add-plans", AddPlans, true),
      createRoute("add-plans/:id", AddPlans, true),
      createRoute("view_plan/:id", ViewPlan, true),
      createRoute("account/company/details/:id", CompanyDetails, true),
      createRoute("user", User, true),
      createRoute("user/details/:id", UserDetails, true),
      createRoute("sifarish", Sifarish, true),
      createRoute("sifarish/getSifarishes", SifarishDetail, true),
      createRoute("reported_sifarish", ReportedSifarish, true),
      createRoute("deleted_sifarish", DeletedSifarish, true),
      createRoute("business_profile_requests", BusinessProfileRequests, true),
      createRoute("business_profile_requests/detail/:sifarishId", BusinessProfileRequestDetail, true),
      createRoute(
        "user/userSifarishes/:userId/:createdByUserId",
        UserSifarishs,
        true
      ),
      createRoute("categories", Categories, true),
      createRoute("categories/categories_details/:id", CategoriesDetail, true),
      createRoute("session", Session, true),
      createRoute("manage_app_version", ManageAppVersion, true),
      createRoute("brodcasting", Brodcasting, true),
      createRoute("contact", Contact, true),
      createRoute("sifarish_points", SifarishPoints, true),
      createRoute("leaderboard", Leaderboard, true),
      createRoute("brodcasting_history", BrodcastingHistory, true),
      createRoute("deleted_user", DeletedUser, true),
    ],
  },
];
